module.exports = __webpack_public_path__ + "img/column_chart.65ddf40a.png";